import {mapState,mapMutations, mapActions} from 'vuex'
import {tokenAndRoute} from "../utils/tokenAndRoute";
import {loaderMixin} from "../utils/loaderMixin";
import copyLinkIcon from '../../components/Svg/things/copyLinkIcon'
import shareIcon from '../../components/Svg/things/shareIcon'
import delIcon from '../../components/Svg/cart_control/delIcon'
import dotsIcon from '../../components/Svg/things/dotsIcon'
import thingOtherMenu from '../../components/Pages/Things/Headers/thignSingle/thingOtherMenu'
import {showOverlay} from "../utils/showOverlay";

export const thingSingleHeader = {
  mixins: [tokenAndRoute, loaderMixin, showOverlay],
  components: {
    copyLinkIcon,
    shareIcon,
    delIcon,
    dotsIcon,
    thingOtherMenu
  },
  data() {
    return {
      showMenu: false
    }
  },
  computed: {
    ...mapState({
      dirName: state => state.things.dirName, //получаем то что передали в дирНейм из дерева (node.name)
      things: state => state.things.device,
      confirmDel: state => state.things.confirm
    }),
    permissionLevel() {
      return this.things.permission_level
    },
    isOwned() {
      return this.things.permissions
    }
  },
  watch: {
    async confirmDel(val) {
      if (val) {
        this.showLoader();
        let data = {
        //  access_token: this.token,
          device_id: this.things.id
        };
        if (this.isGroup) {
          data = {
            //access_token: this.token,
            group_id: this.things.id
          };
          await this.delGroup({data, token: this.token})

        } else {
          await this.delDevice({data, token: this.token});
        }
        this.setDelConfirm(false);
        this.$router.push('/things');
        this.hideLoader();
      }
    }
  },
  methods: {
    ...mapMutations({
      setShowDel: 'things/SET_SHOW_DEL',
      setDelName: 'things/SET_DEL_NAME',
      setDelConfirm: 'things/SET_CONFIRM',
      setShowShare: 'things/SET_SHOW_SHARE',
      setShareName: 'things/SET_SHARE_NAME',
      setShareDeviceType: 'things/SET_SHARE_DEVICE_TYPE'
    }),
    ...mapActions({
      delDevice: 'things/deleteDevice',
      delGroup: 'things/deleteDeviceGroup'
    }),
    showConfirmPopup() {
      this.showOverlay(true);
      this.setShowDel(true);
      this.setDelName([this.things.name]);
    },
    showSharePopup(type = 'device') {
      this.showOverlay(true);
      this.setShowShare(true);
      this.setShareDeviceType(type)
      this.setShareName(this.things.name)
    }
  }
};
